import { checkErrorDniFormat, unFormatDNI } from '@chilecompra/react-kit/utils'
import { differenceInYears, parseISO } from 'date-fns'

/**
 * To check if a DNI corresponds to a natural person or not.
 * This implementation is momentary.
 */
export const checkIsNaturalPerson = value => {
  const cleanValue = unFormatDNI(value?.toString())
  const dni = cleanValue.substring(0, cleanValue.length - 1)

  return parseInt(dni, 10) < 50000000
}

/**
 * To check if the given value corresponds to a foreign seller.
 */
export const checkIfForeignDni = value => !checkErrorDniFormat(value)

/**
 * Returns `true` if birthDateString corresponds to someone under 18.
 * @param {string} birthDateString — ISO date, e.g. "2015-01-01"
 */
export const checkIfIsMinor = birthDateString => {
  if (!birthDateString || birthDateString.startsWith('0000')) {
    return false
  }
  const birthDate = parseISO(birthDateString)
  const age = differenceInYears(new Date(), birthDate)
  return age < 18
}

/**
 * Calculate the verification digit for a RUT
 * @param {string} T
 */
export const calculateDV = T => {
  let M = 0
  let S = 1
  for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11
  return S ? S - 1 : 'k'
}

/**
 * Returns `true` If the value received correctly corresponds to a valid RUT based on the calculated verification digit
 * @param {string} value
 */
export const validateRut = value => {
  if (!checkErrorDniFormat(value)) return false
  const tmp = value.split('-')
  const digv = tmp[1]
  const rut = unFormatDNI(tmp[0])
  return calculateDV(rut).toString() === digv.toLowerCase()
}

/**
 * Check if the received value corresponds to a valid RUT; otherwise, it returns the default custom message.
 * @param {string} customMessage can be undefined
 */
export const checkInputErrorDni = customMessage => {
  return value => (validateRut(value) ? '' : customMessage || 'Formato de RUT no válido.')
}

/**
 * checks if input string can be parsed to a valid json object
 * @param {string} jsonString can be undefined
 */
export const isValidJSON = jsonString => {
  if (!jsonString) {
    return false
  }

  try {
    JSON.parse(jsonString)
    return true
  } catch {
    return false
  }
}
